import { Box } from '@mui/material';
import classNames from 'classnames';
import * as React from 'react';
import { memo } from 'react';

import { FlightTurnaroundDto } from '../../../../../../../backend';
import { getTurnaroundScheduledOccupation } from '../../../../RmsContent.utils';
import { useRmsGanttValue } from '../../../../RmsContext';
import { ganttOneMinuteInMilliSeconds, ganttPxPerMs } from '../../../gantt.constants';
import { getTurnaroundId } from '../../../gantt.utils';
import { TurnaroundData } from '../TurnaroundBox/TurnaroundData';
import {
    StyledScheduledMinTimeBetweenUseBox,
    StyledScheduledTurnaroundBox,
    StyledScheduledTurnaroundFlightNumberBox,
    StyledScheduledTurnaroundZoneBox,
} from './ScheduledTurnaroundBox.style';

export const ScheduledTurnaroundBox = memo(function ScheduledTurnaroundBox({
    turnaround,
    minTimeBetweenUse,
}: {
    turnaround: FlightTurnaroundDto;
    minTimeBetweenUse: number;
}) {
    const dayBounds = useRmsGanttValue('dayBounds');
    const selectedTurnaround = useRmsGanttValue('selectedTurnarounds')?.[0];
    const isFocused = useRmsGanttValue('isFocused');
    const scheduledTurnaroundOccupation = getTurnaroundScheduledOccupation(turnaround);
    const minTimeBetweenUseSize = minTimeBetweenUse * ganttOneMinuteInMilliSeconds * ganttPxPerMs * 2;

    if (!scheduledTurnaroundOccupation?.occupationStart || !scheduledTurnaroundOccupation?.occupationEnd) {
        return null;
    }
    const totalOccupation =
        Math.min(scheduledTurnaroundOccupation.occupationEnd.time, dayBounds?.to) -
        scheduledTurnaroundOccupation.occupationStart.time;

    return (
        <StyledScheduledTurnaroundBox
            marginLeft={`${
                ((scheduledTurnaroundOccupation.occupationStart.time - dayBounds?.from) * 2 || 0) * ganttPxPerMs
            }px`}
            id={`scheduled-${getTurnaroundId(turnaround)}`}
            className={classNames({
                selected:
                    selectedTurnaround &&
                    getTurnaroundId(selectedTurnaround) === getTurnaroundId(turnaround) &&
                    isFocused,
            })}
        >
            <StyledScheduledTurnaroundZoneBox
                sx={{
                    width: totalOccupation * ganttPxPerMs * 2,
                }}
            >
                {(totalOccupation >= 25 * ganttOneMinuteInMilliSeconds ||
                    !turnaround?.arrivalFlight ||
                    !turnaround?.departureFlight) && (
                    <StyledScheduledTurnaroundFlightNumberBox>
                        <TurnaroundData
                            turnaround={turnaround}
                            occupation={totalOccupation}
                            addTargetBoardingTimesIcon={false}
                        />
                    </StyledScheduledTurnaroundFlightNumberBox>
                )}
            </StyledScheduledTurnaroundZoneBox>
            <StyledScheduledMinTimeBetweenUseBox>
                {minTimeBetweenUse > 0 && (
                    <>
                        <Box height={'2px'} width={minTimeBetweenUseSize - 3} bgcolor={'white'} />
                        <Box height={'12px'} width={'2px'} bgcolor={'white'} />
                    </>
                )}
            </StyledScheduledMinTimeBetweenUseBox>
        </StyledScheduledTurnaroundBox>
    );
});
